import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import { TenantProvider } from "./context/TenantContext";
import PrivateRoute from "./components/PrivateRoute";
import AppShell from "./components/AppShell";
import LoginPage from "./Pages/Login";
import GenerateNotesPage from "./Pages/GenerateNotes";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TenantProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <PrivateRoute>
                    <AppShell />
                  </PrivateRoute>
                }
              >
                <Route index element={<GenerateNotesPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
            <ToastContainer position="bottom-right" autoClose={4000} />
          </BrowserRouter>
        </AuthProvider>
      </TenantProvider>
    </ThemeProvider>
  );
}
